import React, { useState, useEffect } from 'react';
import { Route, Switch, HashRouter } from "react-router-dom";
import i18n from 'i18n-js';

import './App.css';
import './styles/font-awesome/css/font-awesome.css';

import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import LoginTv from "./pages/LoginTv";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ActivateAccount from "./pages/ActivateAccount";
import ChannelPreview from "./pages/ChannelPreview";
import ChannelPreview2 from "./pages/ChannelPreview2";
import Channels from "./pages/Channels";
import AllChannels from "./pages/AllChannels";
import ChannelCategory from "./pages/ChannelCategory";
import VODPreview from "./pages/VODPreview";
import Vod from "./pages/Vod";
import AllVOD from "./pages/AllVOD";
import VODCategory from "./pages/VODCategory";
import ChannelPlay from "./pages/ChannelPlay";
import EpgPlay from "./pages/EpgPlay";
import VODPlay from "./pages/VODPlay";
import MyAccount from "./pages/MyAccount";
import ChangePassword from "./pages/ChangePassword";
import ChangePhone from "./pages/ChangePhone";
import ManageSubscriptions from "./pages/ManageSubscriptions";
import ManageSubscriptionsTest from "./pages/ManageSubscriptionsTest";
import mySubscriptions from "./pages/MySubscriptions";
import purchasePlan from "./pages/PurchasePlan";
import changePlan from "./pages/ChangePlan";
import myDevices from "./pages/MyDevices";
import addDevice from "./pages/AdditionalDevice";
import cancelSubscription from "./pages/CancelSubscription";
import terms from "./pages/Terms";
import Unsubscribe from './pages/Unsubscribe';
import UnsubscribeEmail from './pages/UnsubscribeEmail';
import AuthenticateUser from './pages/AuthenticateUser';
import UsePromoCode from './pages/UsePromoCode';

import ProtectedRoute from "./components/protectedRoute";

import DashboardFree from "./pages/DashboardFree";
import ChannelsFree from './pages/ChannelsFree';
import AllChannelsFree from './pages/AllChannelsFree';
import ChannelCategoryFree from "./pages/ChannelCategoryFree";
import ChannelPreviewFree from "./pages/ChannelPreviewFree";
import ChannelPreview2Free from "./pages/ChannelPreview2Free";
import ChannelPlayFree from './pages/ChannelPlayFree';
import EpgPlayFree from './pages/EpgPlayFree';
import AllChannelsMonitoring from './pages/AllChannelsMonitoring';

function App() {
  //const [loadingTranslations, setLoadingTranslations] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [languagesTranslations, setLanguagesTranslations] = useState({ en: { 1: 'Email', 2: 'Password', 3: 'Login', 4: 'Forgot Password?', 5: 'Don\'t have an account?', 6: 'Sign up Now', 7: 'Error', 8: 'Enter your email and password', 9: 'Enter a valid email', 10: 'Account not found', 11: 'Enter your email', 12: 'Success', 13: 'Password reset link has been send to your email', 14: 'Fullname', 15: 'Confirm Password', 16: 'By clicking on register button, you confirm that you have read and agreed with OyaWatch', 17: 'Register', 18: 'Back to login', 19: 'All fields are required', 20: 'Password and confirm password are not the same', 21: 'Account already created', 22: 'Failed, try again', 23: 'Email has already been registered, use another email.', 24: 'Account created successfully', 25: 'Live Tv', 26: 'View all channels', 27: 'more', 28: 'Home', 29: 'VOD', 30: 'Search', 31: 'More', 32: 'All channels', 33: 'Coming Soon!', 34: 'Channel Details', 35: 'Watch Now', 36: 'EPG', 37: 'Yesterday', 38: 'Today', 39: 'Related Contents', 40: 'Live TV Channels', 41: 'Video on Demand', 42: 'My Account', 43: 'Languages', 44: 'Help', 45: 'Terms and Conditions', 46: 'Privacy Policy', 47: 'Cookies Policy', 48: 'Logout', 49: 'Powered by Intradot', 50: 'Personal Details', 51: 'Name', 52: 'Phone', 53: 'My Subscriptions', 54: 'Package', 55: 'Start Date', 56: 'End Date', 57: 'Expired', 58: 'Active', 59: 'My Device', 60: 'Device', 61: 'Last Login', 62: 'Not Active', 63: 'Change Language', 64: 'Selected', 65: 'Search Channel', 66: 'Search VOD', 67: 'Sorry', 68: 'We are currently upgrading this channel.', 69: 'Reset', 70: 'You are not connected to the internet.', 71: 'Please, connect and try again!', 72: 'Reload', 73: 'Connected!', 74: 'Not connected try again!', 75: 'Check your internet connectivity', 76: 'view all VOD', 77: 'My Favourite Channels', 78: 'Do you want to logout?', 79: 'Yes', 80: 'No', 81: 'Cancel', 82: 'Do you need a help?', 83: 'Call Us', 84: 'Email Us', 85: 'Send Us a Direct Message', 86: 'A response message will be sent to your email', 87: 'Message', 88: 'Send', 89: 'Enter a message!', 90: 'Content not available', 91: 'All VOD', 92: 'Live Programs', 93: 'No Subscription' } });

  useEffect(() => {
    if (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined) {
      //console.log('called - no');
      fetch(global.backendDomain + '/api/v1/languages/translations/notoken', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(json => {
          //console.log(json.data.translations);
          if (json.status === 'OK') {
            //setSelectedLanguage(json.data.selected);
            setLanguagesTranslations(json.data.translations);
            //setLoadingTranslations(false);
          }
        });
    } else {
      //console.log('called - yes');
      fetch(global.backendDomain + '/api/v1/languages/translations', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'auth-token': localStorage.getItem('token')
        }
      })
        .then(response => response.json())
        .then(json => {
          //console.log(json.data.translations);
          if (json.status === 'OK') {
            setSelectedLanguage(json.data.selected);
            setLanguagesTranslations(json.data.translations);
            localStorage.setItem('selectedLanguage', json.data.selected);
            //console.log(localStorage.setItem('selectedLanguage', json.data.selected));
            //setLoadingTranslations(false);
          }
        });
    }
    if (localStorage.getItem('selectedLanguage') !== null || localStorage.getItem('selectedLanguage') !== undefined) {
      setSelectedLanguage(localStorage.getItem('selectedLanguage'));
    }
  }, []);

  i18n.translations = languagesTranslations;
  i18n.locale = selectedLanguage;
  i18n.fallbacks = true;

  return (
    <HashRouter>
      <Switch>
        <ProtectedRoute exact path="/" component={Dashboard} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/login/tv/:code" component={LoginTv} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/forgot" component={ForgotPassword} />
        <Route exact path="/unsubscribe/a013658e30387f7a60cdaf0acf26850d" component={Unsubscribe} />
        <Route exact path="/unsubscribe/email/:id/:email" component={UnsubscribeEmail} />
        <Route exact path="/account/reset/:reset_token/:email" component={ResetPassword} />
        <Route exact path="/account/activate/:reset_token/:email" component={ActivateAccount} />
        <Route exact path="/authenticate/token/:token/page/:page" component={AuthenticateUser} />
        <ProtectedRoute exact path="/channels" component={Channels} />
        <ProtectedRoute exact path="/channels/all" component={AllChannels} />
        <ProtectedRoute exact path="/channel/:tag" component={ChannelPreview} />
        <Route exact path="/channel-free/:tag" component={ChannelPreviewFree} />
        <ProtectedRoute exact path="/rechannel/:tag" component={ChannelPreview2} />
        <ProtectedRoute exact path="/channel/play/:tag" component={ChannelPlay} />
        <ProtectedRoute exact path="/epg/play/:item/:tag" component={EpgPlay} />
        <ProtectedRoute exact path="/channels/:category" component={ChannelCategory} />
        <ProtectedRoute exact path="/vods" component={Vod} />
        <ProtectedRoute exact path="/vods/all" component={AllVOD} />
        <ProtectedRoute exact path="/vod/:tag" component={VODPreview} />
        <ProtectedRoute exact path="/vod/play/:tag" component={VODPlay} />
        <ProtectedRoute exact path="/vods/:category" component={VODCategory} />
        <ProtectedRoute exact path="/my-account" component={MyAccount} />
        <ProtectedRoute exact path="/account/change-password" component={ChangePassword} />
        <ProtectedRoute exact path="/account/change-phone" component={ChangePhone} />
        <ProtectedRoute exact path="/manage-subscription" component={ManageSubscriptions} />
        <ProtectedRoute exact path="/manage-subscription-test" component={ManageSubscriptionsTest} />
        <ProtectedRoute exact path="/subscription/view" component={mySubscriptions} />
        <ProtectedRoute exact path="/subscription/purchase" component={purchasePlan} />
        <ProtectedRoute exact path="/subscription/change" component={changePlan} />
        <ProtectedRoute exact path="/subscription/devices" component={myDevices} />
        <ProtectedRoute exact path="/subscription/add-device" component={addDevice} />
        <ProtectedRoute exact path="/subscription/cancel/:id" component={cancelSubscription} />
        <ProtectedRoute exact path="/subscription/promo" component={UsePromoCode} />
        <Route exact path="/terms" component={terms} />

        <Route exact path="/home" component={DashboardFree} />
        <Route exact path="/home/channels" component={ChannelsFree} />
        <Route exact path="/home/channels/all" component={AllChannelsFree} />
        <Route exact path="/home/channels/:category" component={ChannelCategoryFree} />
        <Route exact path="/home/channel/:tag" component={ChannelPreviewFree} />
        <Route exact path="/home/rechannel/:tag" component={ChannelPreview2Free} />
        <Route exact path="/home/channel/play/:tag" component={ChannelPlayFree} />
        <Route exact path="/home/epg/play/:item/:tag" component={EpgPlayFree} />

        <ProtectedRoute exact path="/711ddf023b4a5631df5628c222f73d2d/monitoring/89948c7f4890af5ff18524b4fc3f3611" component={AllChannelsMonitoring} />

        <Route exact path="*" component={NotFound} />
      </Switch>
    </HashRouter>
  );
}

export default App;
